export class MetaData {
	public id: string
	public fileName: string
	public source: string
	public caption: string
	public altText: string
	public accessRight: string
	public fileStorageName: string
	public contentType: string
	public fileSize: number
	public fileSizeUnit: string
	public dimension: {height: number, width: number}
}

export class FileInclMetaData {
	public fileAsBase64: string
	public fileMetaData: MetaData
}



// WEBPACK FOOTER //
// ./src/app/models/meta-data.model.ts